/**
 * IntelliGems A/B Test: Hide PDP geo free shipping pill
 *
 * Control (A): data-hide-geo-shipping-block="false" — block visible
 * Variant (B): data-hide-geo-shipping-block="true"  — block hidden
 *
 * Hiding is CSS-driven via html.hide-geo-shipping-block-b (see hide-geo-shipping-block-ab-test.css).
 *
 * Dev preview: ?hide_geo_shipping_block_test=b
 */
(function () {
  'use strict';

  if (window.__hideGeoShippingBlockABTestInit) return;
  window.__hideGeoShippingBlockABTestInit = true;

  var BODY_ATTR = 'data-hide-geo-shipping-block';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('hide_geo_shipping_block_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    if (value == null) return false;
    var normalized = String(value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) return;

      variantActive = variantB;
      document.documentElement.classList.toggle('hide-geo-shipping-block-b', variantB);
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function observeRoot(root) {
    if (!root || !window.MutationObserver) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(root, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    observeRoot(document.documentElement);
    observeRoot(document.body);

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
